import { Box, CircularProgress, IconButton, Typography } from '@mui/material'

import { useState } from 'react'

import { GRAY_COLORS } from 'asterX-UI'
import { BlueLines } from 'asterX-UI/Icons/BlueLines'
import { DownloadIcon } from 'asterX-UI/Icons/DownloadIcon'
import { FileIcon } from 'asterX-UI/Icons/FileIcon'
import ActionModal from 'asterX-UI/Modals/ActionModal'

import { useContractStore } from 'context/ContractStore'
import { CreditFlow } from 'lib/api/services/creditFlow.service'

const PrintModal = ({ openModal, closeModal = () => {} }) => {
  const [docLoading, setDocLoading] = useState(false)

  const {
    contractStore: { printForms }
  } = useContractStore()

  const handleClose = () => {
    closeModal()
  }

  const openDocument = async doc => {
    try {
      setDocLoading(true)
      const response = await CreditFlow.getTempFilesByField(doc.fileId)
      const blob = new Blob([response.data], { type: 'application/pdf' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = doc.name || 'file' // important!
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      setTimeout(() => URL.revokeObjectURL(url), 100) // revoke after short delay (safer)
    } catch (error) {
      console.error(error)
    } finally {
      setDocLoading(false)
    }
  }

  return (
    <>
      <ActionModal open={!!openModal} onClose={handleClose} title={'Печатные формы'} maxWidth="md">
        <Box display="flex" flexDirection="column" gap="10px">
          {printForms?.length > 0 ? (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                width: '100%'
              }}
            >
              {printForms?.map((item, index) => (
                <Box
                  key={`key-${index}`}
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                    width: '100%'
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      p: 3,
                      borderRadius: '8px',
                      border: `1px solid ${GRAY_COLORS[200]}`,
                      width: '100%'
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                      <Box sx={{ position: 'relative' }}>
                        <FileIcon />
                        <Box
                          sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)'
                          }}
                        >
                          <BlueLines />
                        </Box>
                      </Box>

                      <Box>
                        <Typography
                          variant="body2"
                          sx={{
                            fontSize: 14,
                            fontWeight: 500,
                            wordBreak: 'break-word'
                          }}
                        >
                          {item?.name}
                        </Typography>
                      </Box>
                    </Box>

                    <Box sx={{ display: 'flex', gap: 1 }}>
                      {docLoading ? (
                        <CircularProgress />
                      ) : (
                        <IconButton sx={{ p: 1 }} onClick={() => openDocument(item)}>
                          <DownloadIcon sx={{ color: GRAY_COLORS[600] }} />
                        </IconButton>
                      )}
                    </Box>
                  </Box>
                </Box>
              ))}
            </Box>
          ) : (
            <Box display={'flex'} flexDirection={'column'} alignItems={'center'} justifyContent={'center'} gap={'15px'}>
              <CircularProgress disableShrink />
              <Typography variant="body2" sx={{ fontSize: 14, fontWeight: 500 }}>
                Загрузка печатных форм...
              </Typography>
            </Box>
          )}
        </Box>
      </ActionModal>
    </>
  )
}

export default PrintModal
